import api from "../services/api-gateway";

export async function consultarVersaoGateway(): Promise<any> {
	return api.get("/s610-gateway-servico/v1/versao/versao-gateway");
}
